import { render, staticRenderFns } from "./InputTopTip.vue?vue&type=template&id=d887cb24&scoped=true"
import script from "./InputTopTip.vue?vue&type=script&lang=js"
export * from "./InputTopTip.vue?vue&type=script&lang=js"
import style0 from "./InputTopTip.vue?vue&type=style&index=0&id=d887cb24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d887cb24",
  null
  
)

export default component.exports